export default "__VITE_ASSET__CisH7Nxw__"